import 'epic-react-blog/app/scripts/blogStyles';
import 'font-awesome/css/font-awesome.min.css';
import './news/NewsWrapper.sass';
import './motd/Motd.sass';
import './home/NewHomeView.sass';
